module.exports = __webpack_public_path__ + "img/cheat-false.0f5dfe37.png";